import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import MapView from '@arcgis/core/views/MapView';
import LayerList from '@arcgis/core/widgets/LayerList';

@Component({
  selector: 'app-layers-list-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './layers-list-widget.component.html',
  styleUrls: ['./layers-list-widget.component.scss']
})
export class LayersListWidgetComponent implements OnInit {

  @Input('view') mapview!: MapView;
  @ViewChild('layerListDiv', { static: true }) private layerListRef!: ElementRef;

  constructor(public elem: ElementRef) { }


  ngOnInit() {
    const view = this.mapview;
    
    new LayerList({
      container: this.layerListRef.nativeElement,
      view: view
    });

  }

}
